// extracted by mini-css-extract-plugin
export var base = "ClosingMessageProps-module--base--RbQws";
export var base__box = "ClosingMessageProps-module--base__box--iWs2e";
export var btnBox = "ClosingMessageProps-module--btnBox--3saDC";
export var hitArea = "ClosingMessageProps-module--hitArea--b20xK";
export var linkLineloop = "ClosingMessageProps-module--link-lineloop--17CNw";
export var keyGnav = "ClosingMessageProps-module--key-gnav--1Imni";